import { IEntity } from '@portal/entity-services/interfaces/src';
import { IDevice } from './IDevice';

export interface IPoi {
  altVfiPoiId: string;
  name: string;
  estateManagementId: string;
  description: string;
  type: string;
  verificationCapabilities: string[];
  pinLengthCapability: number;
  approvalCodeLength: number;
  captureCardCapable: boolean;
  partialAuthIndicator: boolean;
  poiUid: string;
  entityUid: string;
  entity?: IEntity;
  device?: IDevice;
  createdDate: Date;
  modifiedDate: Date;
  version: number;
  status: string;
  objectType: string;
}
